import { FilterOption } from '@root/core/interfaces';
import { Checkbox, Col, Form, Input, Row, Select } from 'antd';

import { useEffect, useState } from 'react';
import {
  DANGEROU_GOOD,
  DIMENSION_UNIT,
  LOT_SELECT,
  PACKAGE_METHOD,
  STORAGE_METHOD,
  WEIGHT_UNIT
} from '@root/modules/Warehouse/Inquiry/components/details-pro/types';

interface IProduct {
  image?: {
    url: string;
    id: number;
  };
  productName?: string;
  width?: number;
  height?: number;
  length?: number;
  demensionUnit?: string;
  weight?: number;
  weightUnit?: string;
  estimateQuantity?: number;
  averageMonthSale?: number;
  sku?: string;
  eanUpc?: string;
  asin?: string;
  packedMethod?: any;
  storageMethod?: any;
  dangerousGoods?: string | number | boolean;
  lotProduct?: string;
  id?: Number;
  haveCheck?: Boolean;
  onChangeCheck?: any;
  item?: any;
  isUpdate?: Boolean;
  onChange?: any;
}
function DetailsPro({
  image,
  productName,
  width,
  height,
  length,
  demensionUnit,
  weight,
  weightUnit,
  estimateQuantity,
  averageMonthSale,
  sku,
  eanUpc,
  asin,
  packedMethod,
  storageMethod,
  dangerousGoods,
  lotProduct,
  id,
  haveCheck,
  onChangeCheck,
  item,
  isUpdate,
  onChange
}: IProduct) {
  const [form] = Form.useForm();
  const [checked, setChecked] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [isPackedInput, setIsPackedInput] = useState<boolean>(false);
  const [isStorageMethodInput, setIsStorageMethodInput] =
    useState<boolean>(false);
  const [isLotProductInput, setIsLotProductInput] = useState<boolean>(false);

  useEffect(() => {
    if (isUpdate) {
      setDisabled(false);
    }
  }, [isUpdate]);

  useEffect(() => {
    let a = item;
    packedMethod = packedMethod ? packedMethod.split(', ') : [];
    const isPackedDirect = !PACKAGE_METHOD.map((v) => v.value).includes(
      packedMethod[0]!
    );
    storageMethod = storageMethod ? storageMethod.split(', ') : [];
    const isStorageMethodDirect = !STORAGE_METHOD.map((v) => v.value).includes(
      storageMethod[0]!
    );
    lotProduct = (lotProduct ?? '').toUpperCase();
    const isLotProductDirect = !LOT_SELECT.map((v) => v.value).includes(
      lotProduct
    );

    form.setFieldsValue({
      productName: productName,
      width: width,
      length: length,
      height: height,
      demensionUnit: demensionUnit,
      weight: weight,
      weightUnit: weightUnit,
      estimateQuantity: estimateQuantity,
      averageMonthSale: averageMonthSale,
      sku: sku,
      eanUpc: eanUpc,
      asin: asin,
      packedMethod: isPackedDirect ? ['Direct input'] : packedMethod,
      packedInput: isPackedDirect ? packedMethod : '',
      storageMethod: isStorageMethodDirect ? ['Direct input'] : storageMethod,
      storageMethodInput: isStorageMethodDirect ? storageMethod : '',
      dangerousGoods:
        typeof dangerousGoods === 'boolean'
          ? dangerousGoods
            ? 1
            : 0
          : dangerousGoods,
      lotProduct: isLotProductDirect ? 'Direct input' : lotProduct,
      lotProductInput: isLotProductDirect ? lotProduct : ''
    });
    setIsPackedInput(isPackedDirect);
    setIsStorageMethodInput(isStorageMethodDirect);
    setIsLotProductInput(isLotProductDirect);
  }, [id, productName]);

  useEffect(() => {
    setChecked(false);
  }, [item]);

  return (
    <Form
      layout="vertical"
      form={form}
      style={{ padding: '19px 0px', marginBottom: '10px' }}
      initialValues={{
        productName: '',
        width: '',
        length: '',
        height: '',
        demensionUnit: '',
        weight: '',
        weightUnit: '',
        estimateQuantity: '',
        averageMonthSale: '',
        sku: '',
        eanUpc: '',
        asin: '',
        packedMethod: [],
        packedInput: '',
        storageMethod: [],
        storageMethodInput: '',
        dangerousGoods: '',
        lotProduct: ''
      }}
      onFieldsChange={() => {
        setTimeout(() => {
          onChange?.(form.getFieldsValue());
        });
      }}
    >
      <Row style={{ width: '100%' }}>
        {haveCheck ? (
          <Col span={1}>
            <Checkbox
              value={item}
              checked={checked}
              onChange={(e) => {
                onChangeCheck(e);
                setChecked(!checked);
              }}
            />
          </Col>
        ) : null}
        <Col span={6} style={{ flex: '0 0 25%' }}>
          <div className="image" style={{ padding: '0px 20px' }}>
            {image && image.url !== '' ? (
              <img
                src={image.url}
                style={{ width: '14rem', height: '14rem' }}
              />
            ) : (
              <img
                src="/images/nophoto.jpg"
                style={{ width: '14rem', height: '14rem' }}
              />
            )}
          </div>
        </Col>
        <Col span={haveCheck ? 17 : 18}>
          <Row>
            <Col span={11} style={{ paddingRight: '10px' }}>
              <Form.Item
                label="Product Name"
                name="productName"
                className="proName"
                style={{
                  display: 'inline-block',
                  width: '100%'
                }}
                rules={[
                  {
                    required: true,
                    message: 'Product Name is required'
                  },
                  {
                    max: 20,
                    message: 'Character must be less than 20!'
                  }
                ]}
              >
                <Input
                  style={{ display: 'inline-block', width: '100%' }}
                  disabled={disabled}
                />
              </Form.Item>
            </Col>
            <Col span={13}>
              <Row>
                <div role="cell" className="ant-col ant-form-item-label">
                  <label>Dimensions (Based on unit package)</label>
                </div>
              </Row>
              <Row>
                <Col span={6} style={{ paddingRight: '10px', flex: '0 0 25%' }}>
                  <Form.Item name="width" rules={[{ required: true }]}>
                    <Input
                      disabled={disabled}
                      defaultValue={width}
                      suffix="Width"
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ paddingRight: '10px', flex: '0 0 25%' }}>
                  <Form.Item name="length" rules={[{ required: true }]}>
                    <Input
                      disabled={disabled}
                      defaultValue={length}
                      suffix="Length"
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ paddingRight: '10px', flex: '0 0 25%' }}>
                  <Form.Item name="height" rules={[{ required: true }]}>
                    <Input
                      disabled={disabled}
                      defaultValue={height}
                      suffix="Height"
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ paddingRight: '10px', flex: '0 0 25%' }}>
                  <Form.Item name="demensionUnit" rules={[{ required: true }]}>
                    <Select disabled={disabled} style={{ width: '100%' }}>
                      {DIMENSION_UNIT.map((item: FilterOption) => (
                        <Select.Option key={item.value} value={item.value}>
                          {item.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col span={8} style={{ paddingRight: '10px' }}>
              <Form.Item
                name="weight"
                label="Weight"
                rules={[{ required: true }]}
              >
                <Input disabled={disabled} />
              </Form.Item>
            </Col>
            <Col span={3} style={{ paddingRight: '10px' }}>
              <Form.Item name="weightUnit" label=" ">
                <Select disabled={disabled} style={{ width: '100%' }}>
                  {WEIGHT_UNIT.map((item: FilterOption) => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={13}>
              <Row>
                <Col span={12} style={{ paddingRight: '10px' }}>
                  <Form.Item label="Estimated Quantity" name="estimateQuantity">
                    <Input disabled={disabled} />
                  </Form.Item>
                </Col>
                <Col span={12} style={{ paddingRight: '10px' }}>
                  <Form.Item
                    label="Average Monthly Sale"
                    name="averageMonthSale"
                  >
                    <Input disabled={disabled} />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col span={7} style={{ paddingRight: '10px' }}>
              <Form.Item label="SKU" name="sku">
                <Input disabled={disabled} />
              </Form.Item>
            </Col>
            <Col span={7} style={{ paddingRight: '10px' }}>
              <Form.Item label="EAN/UPC" name="eanUpc">
                <Input disabled={disabled} />
              </Form.Item>
            </Col>
            <Col span={7} style={{ paddingRight: '10px' }}>
              <Form.Item label="ASIN" name="asin">
                <Input disabled={disabled} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={6} style={{ paddingRight: '10px', flex: '0 0 25%' }}>
              <div>
                <Form.Item
                  label="Packing Method"
                  name="packedMethod"
                  rules={[
                    {
                      max: 3,
                      type: 'array',
                      message: 'Choose at least one item and upto 3 items',
                      min: 1,
                      required: true
                    }
                  ]}
                >
                  <Select
                    disabled={disabled}
                    style={{ width: '100%' }}
                    mode="multiple"
                    showArrow
                    getPopupContainer={(node) => node}
                    onChange={(e: string[]) => {
                      if (e.length && e[e.length - 1] === 'Direct input') {
                        form.setFieldsValue({
                          packedMethod: ['Direct input']
                        });
                        setIsPackedInput(true);
                      } else {
                        form.setFieldsValue({
                          packedMethod: e.filter((v) => v !== 'Direct input')
                        });
                        setIsPackedInput(false);
                      }
                    }}
                  >
                    {PACKAGE_METHOD.map((item: FilterOption) => (
                      <Select.Option key={item.value} value={item.value}>
                        {item.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </Col>
            <Col span={6} style={{ paddingRight: '10px', flex: '0 0 25%' }}>
              <div>
                <Form.Item label="Storage Method" name="storageMethod">
                  <Select
                    disabled={disabled}
                    style={{ width: '100%' }}
                    mode="multiple"
                    showArrow
                    getPopupContainer={(node) => node}
                    onChange={(e: string[]) => {
                      if (e.length && e[e.length - 1] === 'Direct input') {
                        form.setFieldsValue({
                          storageMethod: ['Direct input']
                        });
                        setIsStorageMethodInput(true);
                      } else {
                        form.setFieldsValue({
                          storageMethod: e.filter((v) => v !== 'Direct input')
                        });
                        setIsStorageMethodInput(false);
                      }
                    }}
                  >
                    {STORAGE_METHOD.map((item: FilterOption) => (
                      <Select.Option key={item.value} value={item.value}>
                        {item.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </Col>
            <Col span={6} style={{ paddingRight: '10px', flex: '0 0 25%' }}>
              <Form.Item label="Dangerous Goods" name="dangerousGoods">
                <Select
                  disabled={disabled}
                  style={{ width: '100%', textTransform: 'uppercase' }}
                >
                  {DANGEROU_GOOD.map((item: FilterOption) => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6} style={{ paddingRight: '10px', flex: '0 0 25%' }}>
              <div>
                <Form.Item label="Lot Product" name="lotProduct">
                  <Select
                    disabled={disabled}
                    style={{ width: '100%' }}
                    onChange={(e: string) => {
                      if (e === 'Direct input') {
                        form.setFieldsValue({
                          lotProduct: 'Direct input'
                        });
                        setIsLotProductInput(true);
                      } else {
                        form.setFieldsValue({
                          lotProduct: e
                        });
                        setIsLotProductInput(false);
                      }
                    }}
                  >
                    {LOT_SELECT.map((item: FilterOption) => (
                      <Select.Option key={item.value} value={item.value}>
                        {item.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
}

export default DetailsPro;
